<!-- Skeleton con la forma del grid: dos secciones de categoría con sus tarjetas. Va ANTES del
     estado vacío porque «no hay proyectos» es una afirmación, y mientras carga no se sabe. -->
<div class="vision-board" *ngIf="loading" aria-busy="true" aria-label="Cargando proyectos">
  <section class="vb-category" *ngFor="let s of [1, 2]" [ngClass]="'sk-fade-' + s">
    <div class="vb-cat-header">
      <p-skeleton shape="circle" size="1.9rem"></p-skeleton>
      <p-skeleton height="0.95rem" width="11rem"></p-skeleton>
    </div>
    <div class="vb-grid">
      <div class="vb-goal sk-project" *ngFor="let c of [1, 2, 3, 4, 5]">
        <div class="vb-goal-top">
          <p-skeleton shape="circle" size="1.4rem"></p-skeleton>
          <p-skeleton height="0.65rem" width="4.5rem" borderRadius="999px"></p-skeleton>
        </div>
        <p-skeleton height="0.9rem" width="85%"></p-skeleton>
        <p-skeleton height="0.65rem" width="100%"></p-skeleton>
        <p-skeleton height="0.65rem" width="60%"></p-skeleton>
        <div class="vb-goal-foot">
          <p-skeleton height="0.65rem" width="4.5rem"></p-skeleton>
        </div>
      </div>
    </div>
  </section>
</div>

<div class="vision-board" *ngIf="!loading && groups.length">
  <section class="vb-category" *ngFor="let grp of groups">
    <div class="vb-cat-header">
      <span class="vb-cat-icon" [style.background]="grp.category.color"><i [class]="grp.category.icon"></i></span>
      <h4>{{ grp.category.name }}</h4>
      <div class="vb-progress">
        <span class="vb-progress-label">{{ grp.arrancados }}/{{ grp.total }} arrancados</span>
        <div class="vb-progress-bar">
          <div class="vb-progress-fill" [style.width.%]="grp.progress" [style.background]="grp.category.color"></div>
        </div>
      </div>
    </div>

    <div class="vb-grid">
      <div class="vb-goal" *ngFor="let p of grp.projects; let gi = index; trackBy: trackProject" [ngClass]="'ps-' + p.status"
        [style.border-top-color]="grp.category.color" [style.animation-delay.ms]="gi * 60"
        (click)="onPick(p)" (keydown.enter)="onPick(p)" role="button" tabindex="0"
        [attr.aria-label]="'Ver ' + p.project.name">
        <div class="vb-goal-top">
          <span class="vb-goal-icon" [style.color]="grp.category.color"><i [class]="p.project.icon"></i></span>
          <span class="vb-status" [title]="PROJECT_STATUS_META[p.status].hint">
            <i [class]="PROJECT_STATUS_META[p.status].icon" [style.color]="PROJECT_STATUS_META[p.status].color"></i>
            <span [style.color]="PROJECT_STATUS_META[p.status].color">{{ PROJECT_STATUS_META[p.status].label }}</span>
          </span>
        </div>
        <div class="vb-goal-title">{{ p.project.name }}</div>

        <!-- Una línea de qué es, cuando la hay. Es lo que distingue un proyecto aterrizado de un
             título suelto, y la mayoría todavía no la tiene. -->
        <p class="vb-desc" *ngIf="p.project.description">{{ p.project.description }}</p>

        <!-- Con épicas manda el avance del trabajo; sin ellas, los entregables. Sin ninguna de las
             dos no se pinta barra: un 0% se lee como "no avanzamos", no como "no ha empezado". -->
        <div class="vb-work" *ngIf="progressOf(p) as pr">
          <div class="vb-work-bar">
            <div class="vb-work-fill" [style.width.%]="pr.pct" [style.background]="PROJECT_STATUS_META[p.status].color"></div>
          </div>
          <span class="vb-work-lbl">{{ pr.label }}</span>
        </div>

        <div class="vb-goal-foot">
          <span class="vb-date" [class.muted]="!p.project.targetDate">
            <i class="fa-regular fa-calendar"></i> {{ dateLabel(p) }}
          </span>
          <!-- El precio solo existe en la respuesta si quien mira es Admin. -->
          <span class="vb-price" *ngIf="canSeePrice && priceLabel(p) as precio"
            [title]="'Situación: ' + COMMERCIAL_STATUS_META[p.project.commercial!.status].label"
            [style.color]="COMMERCIAL_STATUS_META[p.project.commercial!.status].color">
            <i class="fa-solid fa-tag"></i> {{ precio }}
          </span>
          <span class="vb-team" *ngIf="p.project.origin === 'proposed'" title="Iniciativa del equipo interno de TI">
            <i class="fa-solid fa-lightbulb"></i> Idea de TI
          </span>
          <!-- Atajo a la ficha visual. `stopPropagation` porque la tarjeta entera abre el detalle:
               sin él, el click haría las dos cosas. Solo aparece si la ficha existe — y fuera de
               Admin el backend nunca marca `hasShowcase`, así que ahí no se pinta nunca. -->
          <a class="vb-ficha" *ngIf="p.hasShowcase" [routerLink]="['/roadmap/proyecto', p.project.slug]"
            (click)="$event.stopPropagation()" title="Ver la ficha visual del proyecto">
            <i class="fa-solid fa-image"></i> Ficha
          </a>
        </div>
      </div>
    </div>
  </section>
</div>

<div class="vb-empty" *ngIf="!loading && !groups.length">
    <i class="fa-regular fa-lightbulb"></i>
    <p>Todavía no hay proyectos registrados.</p>
  <button type="button" class="vb-new" (click)="create.emit()">
    <i class="fa-solid fa-plus"></i> Registrar el primero
  </button>
</div>
